import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose caller shows its own error message: the ErrorInterceptor then
 * rethrows the error without the global snackbar (which would print a raw server code).
 * Card #349: the public quote page's accept call.
 */
export const SKIP_ERROR_SNACKBAR = new HttpContextToken<boolean>(() => false);
